var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercarDicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 83.8003387",
    enableBackground: "new 0 0 150 83.8003387",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.5413361,
    y: 24.9027824,
    fill: "#EA5B0C",
    width: 18.9172134,
    height: 33.9947739
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    fill: "#DE0716",
    d: "M66.7425461,41.9001694c0-6.8965569,3.2290802-13.038765,8.2574539-16.9973869 c-3.6774445-2.8949947-8.3175049-4.6222858-13.360836-4.6222858c-11.9393463,0-21.6181107,9.6794281-21.6181107,21.6196728 c0,11.9400635,9.6787643,21.6196709,21.6181107,21.6196709c5.0433311,0,9.6833916-1.7272911,13.360836-4.6222839 C69.9716263,54.938755,66.7425461,48.7967262,66.7425461,41.9001694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F59E00",
    d: "M109.9789505,41.9001694c0,11.9400635-9.678772,21.6196709-21.6181107,21.6196709 c-5.043335,0-9.6833954-1.7272911-13.3608398-4.6222839c5.0284958-3.9588013,8.2573929-10.1008301,8.2573929-16.9973869 S80.0284958,28.8614044,75,24.9027824c3.6774445-2.8949947,8.3175049-4.6222858,13.3608398-4.6222858 C100.3001785,20.2804966,109.9789505,29.9599247,109.9789505,41.9001694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107.9163132,55.296978v-0.6959724h0.280632v-0.1417885h-0.7147064v0.1417885h0.2807541v0.6959724 H107.9163132z M109.3038712,55.296978v-0.8391418h-0.2190781l-0.2519836,0.5771866l-0.2520523-0.5771866h-0.2192001v0.8391418 h0.1547012v-0.6329727l0.2363129,0.5457153h0.160408l0.2363205-0.5470963v0.6343536H109.3038712z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercarDicon);
export default __webpack_public_path__ + "static/media/MASTERCARD.icon.18c1d4422e04cf27bb40678e07726d19.svg";
export { ForwardRef as ReactComponent };